export const bannedDomains = [
  "gmail.com",
  "outlook.com",
  "hotmail.com",
  "yahoo.com",
  "icloud.com",
  "live.com",
  "aol.com",
  "mail.com",
  "msn.com",
  "protonmail.com",
  "zoho.com",
  "yandex.com",
];
